export default [
  {value: '1', label: '开发中'},
  {value: '2', label: '已发布'}
]
